import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from 'hooks/useAuth';
import FullLoader from 'components/loader/full-loader';
import { URLS } from 'utils/constants';

const ProtectedRoute = () => {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return <FullLoader />;  // Menampilkan loader saat memeriksa status login
  }

  if (location.pathname === URLS.ROOT && user) {
    return <Navigate to={URLS.v1.DASHBOARD} replace />;
  }

  return user ? <Outlet /> : <Navigate to={URLS.v1.LOGIN} replace />;
};

export default ProtectedRoute;
